import { faXmark } from "@fortawesome/free-solid-svg-icons/faXmark";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const Component = ({ values, selectedValues, onChange, disabled }) => {
  return (
    <>
      <span>
        {selectedValues.length < values.length && disabled !== true && (
          <select
            value={""}
            onChange={(e) => {
              let newSelectedValues = [...selectedValues];
              if (selectedValues.includes(e.target.value)) {
                // do nothing
              } else {
                newSelectedValues = [...newSelectedValues, e.target.value];
              }
              onChange(newSelectedValues);
            }}
          >
            <option value={""}></option>
            {values
              .filter((v) => !selectedValues.includes(v))
              .map((value, idx) => (
                <option value={value} key={idx}>
                  {value}
                </option>
              ))}
          </select>
        )}
        {selectedValues.map((selectedValue, idx) => (

          <span key={idx}>
            {disabled !== true && (
              <FontAwesomeIcon
                icon={faXmark}
                className="icon-clickable"
                onClick={() =>
                  onChange(selectedValues.filter((s) => s !== selectedValue))
                }
              ></FontAwesomeIcon>
            )}
            &nbsp;
            {selectedValue}
            <br></br>
          </span>
        ))}
      </span>
    </>
  );
};

export default Component;
